import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const createPaymentAPI = async ({authToken, subsidiaryId, customerId, amount}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);

    const URL = `${BASE_URL}/${requestSubsidiaryId}/client/customer/${customerId}/payment-request-bunq`
    const METHOD = "POST"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify({
            amount,
            type: "customer_triggered_payment",
            source: "web_top_up"
        })
    })

    if (!response.ok) {
        let errorPayload = null
        try {
            errorPayload = await response.json()
        } catch (parseError) {
            errorPayload = null
        }

        const error = new Error(errorPayload?.message || `HTTP error: ${response.status}`)
        error.status = response.status
        error.payload = errorPayload
        throw error
    }

    return await response.json()
}

export {createPaymentAPI}
